import styled from 'styled-components'

export const Section = styled.div`
  margin: 0.3rem 0.4rem;
`

export const SectionTitle = styled.div`
  font-size: 0.42rem;
  font-weight: 700;
  color: var(--theme-color);
  margin-bottom: 0.2rem;
`

export const InfoRow = styled.div`
  font-size: 0.36rem;
  color: var(--main-color);
  padding: 0.08rem 0;
  word-break: break-all;
`

export const Label = styled.span<{ $ml?: boolean }>`
  opacity: 0.6;
  margin-right: 0.2rem;
  ${(p) => p.$ml && 'margin-left: 0.3rem;'}
`

export const Badge = styled.span<{ $success?: boolean }>`
  display: inline-block;
  padding: 0.02rem 0.16rem;
  border-radius: 0.1rem;
  font-size: 0.32rem;
  background: ${(p) =>
    p.$success ? 'var(--success-color-light, rgba(76,175,80,0.15))' : 'var(--danger-color-light, rgba(244,67,54,0.15))'};
  color: ${(p) => (p.$success ? 'var(--success-color, #4caf50)' : 'var(--danger-color)')};
`

export const CandidateCard = styled.div`
  background: var(--page-view-comic--card-background);
  border-radius: 0.2rem;
  padding: 0.3rem;
  margin-bottom: 0.2rem;
`

export const DataValBlock = styled.pre`
  background: var(--page-view-comic--card-background);
  border-radius: 0.2rem;
  padding: 0.3rem;
  font-size: 0.32rem;
  color: var(--main-color);
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 8rem;
  overflow: auto;
`

export const MonospaceText = styled.span`
  font-family: monospace;
  font-size: 0.32rem;
`

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
  color: var(--main-color);
  opacity: 0.5;
  padding: 2rem;
  text-align: center;
`

export const SafeBottomPadding = styled.div`
  height: env(safe-area-inset-bottom);
`
